/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_ReactivateInputs */



/**
* | output |
* | --- |
* | "Reactivate" |
*
* @param {Promo_ReactivateInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_reactivate = /** @type {((inputs?: Promo_ReactivateInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_ReactivateInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Réactiver")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reactivar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Reativar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Riattiva")
	return /** @type {LocalizedString} */ ("Reactivate")
});